import { Injectable, Output, EventEmitter } from '@angular/core';

@Injectable()
export class RightPanelService {
  @Output() togglePanel: EventEmitter<any> = new EventEmitter<any>();

  toggle(toggle?: boolean): void {
    this.togglePanel.emit(toggle);
  }
}
